export enum ProfileRequestMethodEnum {
  UserProfileSave = 'userProfileSave',
  CompanyProfileSave = 'companyProfileSave',
  SetupProfileSave = 'setupProfileSave',
  ChangeUserEmail = 'changeUserEmail',
  ChangeUserPassword = 'changeUserPassword',
  ChangeUserReportsFrequency = 'changeUserReportsFrequency',
}
